module.exports = __webpack_public_path__ + "static/media/Instagram.703479fd.svg";